import { createFileRoute, Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

export const Route = createFileRoute("/terms")({
  component: TermsPage,
});

function TermsPage() {
  return (
    <main className="mx-auto max-w-[900px] px-5 py-8 sm:px-8 sm:py-12">
      <Link
        to="/"
        className="font-mono text-[12px] uppercase tracking-[0.12em] text-fg-muted transition-colors hover:text-fg"
      >
        Runboom
      </Link>
      <h1 className="mt-8 font-display text-[52px] leading-[46px] tracking-[0] text-fg sm:text-[76px] sm:leading-[66px]">
        Terms
      </h1>
      <p className="mt-5 max-w-[70ch] font-mono text-[13px] uppercase leading-6 tracking-[0.08em] text-fg-muted">
        Runboom gives amateur runners a sharper way to understand race
        readiness. Predictions are estimates for training and motivation, not
        guarantees of performance, medical advice, coaching advice, or official
        race results.
      </p>

      <div className="mt-10 space-y-8 border-t border-border pt-8 font-mono text-[13px] leading-6 text-fg-muted">
        <TermsSection title="Use of the product">
          Athletes are responsible for how they train and race. Runboom may
          change predictions, ranking views, races, and product features as the
          product evolves.
        </TermsSection>

        <TermsSection title="Strava connection">
          Athletes connect to Strava through OAuth and can revoke access at any
          time in Runboom or from their Strava account settings. Runboom is not
          developed by, sponsored by, or endorsed by Strava.
        </TermsSection>

        <TermsSection title="Race events">
          Race pages are intended to increase race discovery and participation.
          Runboom is not an official race operator unless explicitly stated by a
          race organizer.
        </TermsSection>

        <TermsSection title="Contact">
          Product support and account questions can be sent to marc@ollie.health.
        </TermsSection>
      </div>
    </main>
  );
}

function TermsSection({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <section>
      <h2 className="font-mono text-[12px] uppercase tracking-[0.12em] text-fg">
        {title}
      </h2>
      <p className="mt-2">{children}</p>
    </section>
  );
}
